import { render, staticRenderFns } from "./connections.vue?vue&type=template&id=06c60c6c&scoped=true&"
import script from "./connections.vue?vue&type=script&lang=js&"
export * from "./connections.vue?vue&type=script&lang=js&"
import style0 from "./connections.vue?vue&type=style&index=0&id=06c60c6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c60c6c",
  null
  
)

export default component.exports